import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import { ReplaySubject, BehaviorSubject, catchError, Observable, map } from 'rxjs';

import { MessageService } from 'src/app/core/services/message.service';
import { PageDonnee } from 'src/app/shared/interfaces/page-donnee';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  constructor(
    private messageService: MessageService
    ,private http: HttpClient
    ) { }

   private donneesSubject = new BehaviorSubject<any[]>([]);
   public donnees$ = this.donneesSubject.asObservable();

   private chargementSubject = new BehaviorSubject<boolean>(false);
   public chargement$ = this.chargementSubject.asObservable();

   private indexPageSubject = new ReplaySubject<number>(0);
   public indexPage$ = this.indexPageSubject.asObservable();

   private taillePageSubject = new ReplaySubject<number>(10);
   public taillePage$ = this.taillePageSubject.asObservable();

   private totalElementsDonneesSubject = new BehaviorSubject<number>(0);
   public totalElementsDonnees$ = this.totalElementsDonneesSubject.asObservable();

  obtenirListeZones(page:number, taille:number) {
    const url = `${environment.apiurl}zones/actives`;
    this.http.get<any[]>(url).subscribe(donnees => {
      const list = Array.isArray(donnees) ? donnees : [];
      this.donneesSubject.next(list);
      this.chargementSubject.next(false);
      this.indexPageSubject.next(0);
      this.totalElementsDonneesSubject.next(list.length);
    });
  }

  obtenirZoneParId(id: number): Observable<any> {
    const url = `${environment.apiurl}zones/${id}`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  enregistrerZone(formulaireZone: any): Observable<any> {
    const url = `${environment.apiurl}zones`;
    const body = {
      nom: formulaireZone.nom,
      description: formulaireZone.description ?? '',
      villeId: formulaireZone.villeId ?? null
    };
    return this.http.post<any>(url, body).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  modifierZone(formulaireZone: any): Observable<any> {
    const url = `${environment.apiurl}zones/${formulaireZone.id}`;
    const { id, ...donneesZone } = formulaireZone;
    return this.http.put<any>(url, donneesZone).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  supprimerZone(id: number): Observable<any> {
    const url = `${environment.apiurl}zones/${id}`;
    return this.http.delete<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirToutesLesZones(max: number = 500): Observable<any[]> {
    const url = `${environment.apiurl}zones/actives`;
    return this.http.get<any[]>(url).pipe(
      map(res => (Array.isArray(res) ? res.slice(0, max) : [])),
      catchError(this.messageService.gererErreur)
    );
  }

}
